import { Box, Button, Paper, Stack, Typography, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Table } from 'react-bootstrap'
import Pagination from './general/Pagination'
import ExportContent from './ExportContent'
import generatePDF from 'react-to-pdf';
import { getFromTo } from '../utils'
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import AppModal from './AppModal'
import ExportPdf from './exportPdf/ExportPdf'
import { PASS_KEY, WEB_KEY, BaseUrl } from '../api/AxiosApi'
import { AuthenticationContext } from '../context/AuthenticationContext'
import logo from '../assets/img/logos/logo 2.png';


export default function TwoHeadTable({ WM_TYPE, radiationName, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const tableRef = useRef(null);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(15);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)


    const LOGIN_ID = localStorage.getItem("LoginID") ?? ""

    const LOC_CODE = localStorage.getItem("LCODE") ?? ""

    const currentRecords1 = TableData;

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const handleTabChange = () => {
        setCurrentPage(1);
        // Add any additional logic if needed
    };

    // function genPDF() {
    //     const textX = 20; // Adjust the X-coordinate as needed
    //     const textY = 20; // Adjust the Y-coordinate as needed
    //     const logoWidth = 50; // Adjust the logo width as needed
    //     const logoHeight = 30; // Adjust the logo height as needed
    //     const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

    //     // Add image dynamically
    //     const imgData = require('../assets/img/logos/logo 2.png');

    //     // Get the width of the PDF document
    //     const pdfWidth = pdf.internal.pageSize.getWidth();

    //     // Calculate the X-coordinate to center the logo
    //     const logoX = (pdfWidth - logoWidth) / 2;

    //     // Add table content using autotable
    //     pdf.setFontSize(12);

    //     // Add the centered logo
    //     pdf.addImage(imgData, 'JPEG', logoX, textY + 5, logoWidth, logoHeight);

    //     // Add title centered on the page
    //     const title = ` ${radiationName} ${ValueOf2}`;
    //     const titleWidth = pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
    //     const titleX = (pdfWidth - titleWidth) / 2;

    //     pdf.text(title, titleX, textY + 5 + logoHeight + 10);

    //     pdf.autoTable({
    //         html: '#table-toPdf1', // specify the table ID
    //         startY: textY + 5 + logoHeight + 20, // Adjust the Y-coordinate as needed
    //         columnStyles: {
    //             2: { cellWidth: 50 }, // Adjust the cell width for the "Radiation Name" column
    //         },
    //     });

    //     // Save or download the PDF
    //     pdf.save(`Solar Radiation To ${ValueOf2} ${radiationName}.pdf`);
    // }

    function genPDF() {
        const textX = 20; // Left side margin
        const textY = 20; // Top margin
        const logoWidth = 50;
        const logoHeight = 30;
    
        const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });
    
        // Import images
        const imgData = require('../assets/img/logos/logo 2.png'); // Center logo
        // If you want a right-side logo, pass ImageUrl dynamically
    
        const pdfWidth = pdf.internal.pageSize.getWidth();
    
        // --- LEFT SIDE TEXT (Company Details) ---
        pdf.setFontSize(15);
        pdf.setFont("helvetica", "bold");
        pdf.text(`Plant Name/User Name: ${LoggedInUserInfo?.username || ""}`, textX, textY + 10);
    
        pdf.setFontSize(10);
        pdf.text(`Plant Capacity : ${LoggedInUserInfo?.PLANT_CAPACITY || ""}`, textX, textY + 16);
        pdf.text(`Plant Address : ${LoggedInUserInfo?.Address || ""}`, textX, textY + 22);
    
        // --- CENTER LOGO ---
        const logoX = (pdfWidth - logoWidth) / 2;
        pdf.addImage(imgData, 'JPEG', logoX, textY, logoWidth, logoHeight);
    
        // --- RIGHT SIDE LOGO (optional, if you have one) ---
        if (ImageUrl) {
            const rightImgWidth = 100;
            const rightImgHeight = 35;
            const rightX = pdfWidth - rightImgWidth - 20; // 20px margin from right
            pdf.addImage(ImageUrl, 'JPEG', rightX, textY, rightImgWidth, rightImgHeight);
        }
    
        // --- TITLE BELOW HEADER ---
        const title = `${radiationName} ${ValueOf2}`;
        pdf.setFontSize(12);
        const titleWidth =
            pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const titleX = (pdfWidth - titleWidth) / 2;
        pdf.text(title, titleX, textY + logoHeight + 15);
    
        // --- TABLE CONTENT ---
        pdf.autoTable({
            html: '#table-toPdf1', // keep your old table id
            startY: textY + logoHeight + 25,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 2 }, // to fit better
            headStyles: { fillColor: [1, 59, 123] },
            pageBreak: "auto", // paginate automatically
            margin: { left: 20, right: 20 }
        });
    
        // --- SAVE FILE ---
        pdf.save(`Solar Radiation To ${ValueOf2} ${radiationName}.pdf`);
    }
    
   


    if (!TableData || TableData.length === 0) {
        return <Typography variant='body2' p={10} color={'error.main'} textAlign={'center'}>Data Not Found</Typography>;
    }


    const dataKeyMap = {
        'Solar Irradiance-2': 'Solar Irradiance-2',
        "Solar Irradiation-3": "Solar_Irradiation-3",
        "Solar Irradiation-4": "Solar_Irradiation-4",
        "Solar Irradiation-5": "Solar_Irradiation-5",
        "Solar Irradiation-6": "Solar_Irradiation-6",
        "Solar Irradiation-7": "Solar_Irradiation-7",

    };

    return (
        <Box>
            {
                currentRecords1?.length > 0 ? <>
                    <ExportContent
                        excelTableRef={tableRef}
                        onGenPdf={genPDF}
                        ExcelExportFileName={`Solar Radiation To ${ValueOf2} ${radiationName}`}
                        title={radiationName}
                        onFullScreen={handleOpen}
                        filterContent={
                            <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                <Box flex={1} columnGap={2} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Stack direction={'row'} alignItems={'center'} columnGap={1}>
                                        <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                                    </Stack>
                                    <Typography variant='body1' >To</Typography>
                                    <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                                    {/* <AutorenewIcon onClick={onRefreshData} sx={[styles.IconStyle]} /> */}
                                    <Button onClick={onRefreshData} variant='contained' sx={{ color: 'backround.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                                </Box>
                            </Stack>
                        }
                    />


                    <Box flexGrow={1}>
                        <>
                            <Table style={{}} id='table-toPdf' ref={tableRef} striped bordered hover responsive>
                                <thead style={{}}>
                                    <tr style={{ textAlign: 'center' }}>
                                        {
                                            TableHead?.map((item, index) => {
                                                return (
                                                    <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords?.map((item, index) => {

                                            return (
                                                <tr key={index} style={{ textAlign: 'center' }}>
                                                    <td>{item?.Sn}</td>
                                                    <td>{item?.DateTime}</td>
                                                    {/* {
                                                        radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item?.DateTime}</td>
                                                    } */}

                                                    {/* <td>{item[`${radiationName}`]}</td> */}
                                                    <td>{item[dataKeyMap[radiationName] || radiationName]}</td>

                                                    {
                                                        radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRRADIANCE' : 'MIN_VALUE']}</td>

                                                    }
                                                    {
                                                        radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRR.TIME' : 'MAX_VALUE']}</td>

                                                    }

                                                    {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['AVG_VALUE']}</td>}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>

                            <Table style={{ display: "none" }} id='table-toPdf1' ref={tableRef} striped bordered hover responsive>
                                <thead style={{}}>
                                    <tr style={{ textAlign: 'center' }}>
                                        {
                                            TableHead?.map((item, index) => {
                                                return (
                                                    <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords1?.map((item, index) => {
                                            // console.log('data', item)
                                            return (
                                                <tr key={index} style={{ textAlign: 'center' }}>
                                                    <td>{item?.Sn}</td>
                                                    <td>{item?.DateTime}</td>
                                                    {/* {
                                                        radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item?.DateTime}</td>
                                                    } */}

                                                    <td>{item[`${radiationName}`]}</td>
                                                    {
                                                        radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRRADIANCE' : 'MIN_VALUE']}</td>

                                                    }
                                                    {
                                                        radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRR.TIME' : 'MAX_VALUE']}</td>

                                                    }

                                                    {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['AVG_VALUE']}</td>}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>

                            <Box
                                sx={{ display: 'flex', justifyContent: 'end' }}
                            >
                                <Pagination
                                    nPages={nPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                // scrollToBottom={scrollToBottom}
                                />
                            </Box>
                        </>

                    </Box>



                    <AppModal open={open} handleClose={handleClose}>
                        <Box flexGrow={1}>
                            <Typography textAlign={'center'} my={3} variant='h5'>{radiationName}</Typography>
                            <>
                                <Table style={{}} id='table-toPdf' ref={tableRef} striped bordered hover responsive>
                                    <thead style={{}}>
                                        <tr style={{ textAlign: 'center' }}>
                                            {
                                                TableHead?.map((item, index) => {
                                                    return (
                                                        <th style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentRecords?.map((item, index) => {
                                                // console.log('data', item)
                                                return (
                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                        <td>{item?.Sn}</td>
                                                        <td>{item?.DateTime}</td>
                                                        {/* {
                                                        radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item?.DateTime}</td>
                                                    } */}

                                                        <td>{item[`${radiationName}`]}</td>
                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRRADIANCE' : 'MIN_VALUE']}</td>

                                                        }
                                                        {
                                                            radiationName == 'Wind Direction' ? null : <td>{item[radiationName == 'Solar Insolation' ? 'PEAK IRR.TIME' : 'MAX_VALUE']}</td>

                                                        }

                                                        {radiationName == 'Solar Insolation' || radiationName == 'Wind Direction' ? null : <td>{item['AVG_VALUE']}</td>}
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                                <Box
                                    sx={{ display: 'flex', justifyContent: 'end' }}
                                >
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    // scrollToBottom={scrollToBottom}
                                    />
                                </Box>
                            </>

                        </Box>
                    </AppModal>



                </>

                    : <>
                        <Typography variant='body2' color={'error.main'} textAlign={'center'}>Data Not Found</Typography>
                    </>
            }
        </Box>
    )
}
